import { Box, Flex, Stack, Text } from '@chakra-ui/react';
// import dayjs from 'dayjs';
// import { FcInvite } from 'react-icons/fc';
// import { useNavigate } from 'react-router-dom';
import { MenuItems } from './Menu';
// import { Popover } from '../../../components/Popover';

const ContactList = ({ contactList, userId, setRefresh }) => {
  const { guestName, phoneNumber } = contactList;
  // const navigate = useNavigate()
  // console.log("pprr", contactList)

  return (
    <Box p='20px' borderRadius='10px' boxShadow='sm'>
      <Flex justify='space-between' align='center'>
        {/*<Avatar guestName='Kent Dodds' src='https://bit.ly/kent-c-dodds' />*/}

        <Stack fontSize='0.8rem'>
          <Text fontSize='1.1rem' fontWeight='500' color='#614385'>
            {guestName}
          </Text>
          {/* <Text>Last day of visit {dayjs(endDate).format('DD/MMM/YYYY')}</Text> */}
          <Text m='0 !important'>
            {phoneNumber}
            {/* {allowCompany ? 'With Company' : 'Without Company'} */}
          </Text>
        </Stack>
        <Box alignSelf={'flex-end'}>
          <MenuItems
            contactList={contactList}
            userId={userId}
            setRefresh={setRefresh}
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default ContactList;
